import React from "react";
import { ChevronDown, Download, Loader2 } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../ui/dropdown-menu";
import { EXPORT_FORMATS } from "../../lib/exportFile";

/**
 * "Export", then Excel or CSV (15.10.2026). Every export in the admin uses
 * it, so they all offer the same two, in the same order. The button keeps
 * the look of the place it sits in (`className`).
 */
export default function ExportButton({ onExport, label = "Export", className, testid, title, disabled, busy }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild disabled={disabled || busy}>
        <button type="button" className={className} title={title} data-testid={testid} disabled={disabled || busy}>
          {busy ? <Loader2 size={14} className="animate-spin" /> : <Download size={14} />} {label}
          <ChevronDown size={13} className="opacity-70" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {EXPORT_FORMATS.map((f) => (
          <DropdownMenuItem key={f.key} onSelect={() => onExport(f.key)} data-testid={testid ? `${testid}-${f.key}` : undefined}>
            {f.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
